import React, { useMemo } from 'react'

import OfferList from 'components/OfferList/OfferList'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { ANYWHERE_PLACE_ID } from 'constants/search'
import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_BED_BANK, OFFER_TYPE_HOTEL, OFFER_TYPE_VILLA } from 'constants/offer'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'

const DEFAULT_OCCUPANTS: Array<App.Occupants> = [{ adults: 2 }]
const StyledVerticalSpacer = styled(VerticalSpacer)`
  padding-top: ${rem(22)};
`

function HotelSearchNoSearchResultSectionAlternativeOffers(
) {
  const listFilters = useMemo((): App.OfferListFilters => {
    return {
      destinationId: ANYWHERE_PLACE_ID,
      offerTypes: [OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_VILLA, OFFER_TYPE_HOTEL, OFFER_TYPE_BED_BANK],
      distanceEq: 0,
      rooms: DEFAULT_OCCUPANTS
    }
  }, [])

  return (

    <StyledVerticalSpacer gap={24}>
      <div>
        <Heading variant="heading5">No exact matches for your search</Heading>
        <BodyText variant="large">We've found related escapes we think you'll love.</BodyText>
      </div>
      <OfferList filters={listFilters} tileStyle="search" eagerLoadFirstImage />
    </StyledVerticalSpacer>

  )
}

export default HotelSearchNoSearchResultSectionAlternativeOffers
